export default function mobileStepper({ variables, }) {
    return {
        MuiMobileStepper: {
            styleOverrides: {
                root: {
                    backgroundColor: variables.surface,
                    padding: variables.spacing_03,
                },
                dot: {
                    backgroundColor: variables.surface_raised,
                },
                dotActive: {
                    backgroundColor: variables.interactive,
                },
                progress: {
                    backgroundColor: variables.surface_track,
                },
            },
        },
    };
}
//# sourceMappingURL=mobileStepper.js.map